// recurring transaction frequency
export var RecurringTransactionFrequency;
(function (RecurringTransactionFrequency) {
    RecurringTransactionFrequency["DAILY"] = "DAILY";
    RecurringTransactionFrequency["WEEKLY"] = "WEEKLY";
    RecurringTransactionFrequency["EVERY_2_WEEKS"] = "EVERY_2_WEEKS";
    RecurringTransactionFrequency["EVERY_3_WEEKS"] = "EVERY_3_WEEKS";
    RecurringTransactionFrequency["EVERY_4_WEEKS"] = "EVERY_4_WEEKS";
    RecurringTransactionFrequency["MONTHLY"] = "MONTHLY";
    RecurringTransactionFrequency["EVERY_2_MONTHS"] = "EVERY_2_MONTHS";
    RecurringTransactionFrequency["EVERY_3_MONTHS"] = "EVERY_3_MONTHS";
    RecurringTransactionFrequency["EVERY_4_MONTHS"] = "EVERY_4_MONTHS";
    RecurringTransactionFrequency["EVERY_6_MONTHS"] = "EVERY_6_MONTHS";
    RecurringTransactionFrequency["YEARLY"] = "YEARLY";
    RecurringTransactionFrequency["EVERY_2_YEARS"] = "EVERY_2_YEARS";
})(RecurringTransactionFrequency || (RecurringTransactionFrequency = {}));
